module.exports = __webpack_public_path__ + "static/full-logo-fc31d8d1845d38cd6054c3d0b5064e5d.png";